import SignupComponent from "../../Auth/signup";

export default function CreateNewUser (){
return(
    <SignupComponent/>
)    
}